import { motion } from 'framer-motion';

import { tv } from '@/utils/styles';

import { extraNavButtonIconVariants, extraNavButtonTextVariants } from '../utils/transitions';

interface Props {
  onClick: () => void;
  buttonText: string;
  icon: JSX.Element;
  visibility: string;
  className?: string;
}

const ExtraNavButton = ({ onClick, buttonText, icon, visibility, className }: Props) => {
  const { base, inner, text, iconWrapper, iconBg } = styles();

  return (
    <button onClick={onClick} type="button" className={base({ className })}>
      <span className={inner()}>
        <motion.span variants={extraNavButtonTextVariants} animate={visibility} initial={visibility} className={text()}>
          {buttonText}
        </motion.span>
        <motion.span
          variants={extraNavButtonIconVariants}
          animate={visibility}
          initial={visibility}
          className={iconWrapper()}
        >
          {icon}
        </motion.span>
      </span>
      <span className={iconBg()} />
    </button>
  );
};

const styles = tv({
  slots: {
    base: 'relative block w-full border-0 px-2 py-2.5 pl-2.5 [&_.icon-bg]:hover:scale-100 [&_.icon-bg]:hover:opacity-100 [&_svg]:text-lightBlue-500',
    inner: 'relative z-2 flex w-full justify-between',
    text: 'block whitespace-nowrap text-baseSm',
    iconWrapper: 'absolute right-0 top-1/2 block -translate-y-1/2',
    iconBg:
      'icon-bg pointer-events-none absolute bottom-0 left-0 right-0 top-0 z-1 block scale-75 rounded bg-blue-500 opacity-0 transition-all',
  },
});

export { ExtraNavButton };
